import styled from 'styled-components/native';
import FontAwesome from 'react-native-vector-icons/dist/FontAwesome';
import {RFPercentage, RFValue} from 'react-native-responsive-fontsize';

export const Container = styled.View`
  position: absolute;
  z-index: 301;
  top: ${RFPercentage(50)}px;
  left: 12px;
`;

export const IconDev = styled.TouchableOpacity`
  background: ${({theme}) => theme.colors.primary};
  width: ${RFValue(50)}px;
  height: ${RFValue(50)}px;
  shadow-color: #000;
  shadow-offset: 0px 4px;
  shadow-opacity: 0.2;
  shadow-radius: 8px;
  elevation: 5;
  border-radius: ${RFValue(25)}px;
  justify-content: center;
  align-items: center;
`;

export const BtnIcon = styled(FontAwesome)`
  color: ${({theme}) => theme.colors.shape};
  font-size: ${RFValue(22)}px;
`;

export const ModalContainer = styled.View``;

/* ── MODAL CARD ── */

export const Card = styled.View`
  background-color: ${({theme}) => theme.colors.background};
  margin: 0 20px;
  border-radius: ${RFValue(20)}px;
  max-height: 82%;
  shadow-color: #000;
  shadow-offset: 0px 8px;
  shadow-opacity: 0.12;
  shadow-radius: 20px;
  elevation: 10;
  overflow: hidden;
`;

/* ── HEADER ── */

export const Header = styled.View`
  flex-direction: row;
  align-items: center;
  padding: ${RFValue(16)}px ${RFValue(16)}px ${RFValue(14)}px;
`;

export const HeaderIconWrap = styled.View`
  background-color: ${({theme}) => theme.colors.primary}20;
  width: ${RFValue(34)}px;
  height: ${RFValue(34)}px;
  border-radius: ${RFValue(10)}px;
  justify-content: center;
  align-items: center;
  margin-right: ${RFValue(10)}px;
`;

export const HeaderIcon = styled(FontAwesome)`
  color: ${({theme}) => theme.colors.primary};
  font-size: ${RFValue(16)}px;
`;

export const HeaderTitle = styled.Text`
  flex: 1;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(15)}px;
`;

export const HeaderSubtitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(10)}px;
  margin-top: ${RFValue(1)}px;
`;

export const CloseButton = styled.TouchableOpacity`
  background-color: ${({theme}) => theme.colors.price_card};
  width: ${RFValue(28)}px;
  height: ${RFValue(28)}px;
  border-radius: ${RFValue(14)}px;
  justify-content: center;
  align-items: center;
`;

export const CloseIcon = styled(FontAwesome)`
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(12)}px;
`;

export const HeaderSeparator = styled.View`
  height: 1px;
  background-color: ${({theme}) => theme.colors.border2};
  margin: 0 ${RFValue(16)}px;
`;

/* ── BODY ── */

export const Body = styled.ScrollView.attrs(() => ({
  showsVerticalScrollIndicator: false,
  contentContainerStyle: {
    padding: RFValue(16),
    paddingTop: RFValue(14),
  },
}))``;

/* ── SECTION LABEL ── */

export const SectionLabel = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(10)}px;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  margin-bottom: ${RFValue(8)}px;
`;

/* ── CURRENT ROUTE ── */

export const RouteChip = styled.View`
  flex-direction: row;
  align-items: center;
  align-self: flex-start;
  background-color: ${({theme}) => theme.colors.primary}15;
  border-radius: ${RFValue(20)}px;
  padding: ${RFValue(5)}px ${RFValue(10)}px;
  margin-bottom: ${RFValue(10)}px;
  gap: ${RFValue(5)}px;
`;

export const RouteChipIcon = styled(FontAwesome)`
  color: ${({theme}) => theme.colors.primary};
  font-size: ${RFValue(11)}px;
`;

export const RouteChipText = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.primary};
  font-size: ${RFValue(12)}px;
`;

export const InputWrapper = styled.View`
  flex-direction: row;
  align-items: center;
  background-color: ${({theme}) => theme.colors.price_card};
  border-radius: ${RFValue(10)}px;
  padding: 0 ${RFValue(12)}px;
  height: ${RFValue(40)}px;
  margin-bottom: ${RFValue(10)}px;
  gap: ${RFValue(8)}px;
`;

export const InputIcon = styled(FontAwesome)`
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(13)}px;
`;

export const LabelInput = styled.TextInput`
  flex: 1;
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(13)}px;
  color: ${({theme}) => theme.colors.title};
`;

export const SaveButton = styled.TouchableOpacity`
  background-color: ${({theme}) => theme.colors.primary};
  border-radius: ${RFValue(10)}px;
  height: ${RFValue(40)}px;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: ${RFValue(7)}px;
`;

export const SaveButtonIcon = styled(FontAwesome)`
  color: ${({theme}) => theme.colors.shape};
  font-size: ${RFValue(13)}px;
`;

export const SaveButtonText = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.shape};
  font-size: ${RFValue(12)}px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const NoRouteBox = styled.View`
  flex-direction: row;
  align-items: center;
  background-color: ${({theme}) => theme.colors.price_card};
  border-radius: ${RFValue(10)}px;
  padding: ${RFValue(12)}px;
  gap: ${RFValue(10)}px;
`;

export const NoRouteIcon = styled(FontAwesome)`
  color: ${({theme}) => theme.colors.attention};
  font-size: ${RFValue(18)}px;
`;

export const NoRouteText = styled.Text`
  flex: 1;
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(12)}px;
`;

/* ── DIVIDER ── */

export const Divider = styled.View`
  height: 1px;
  background-color: ${({theme}) => theme.colors.border2};
  margin: ${RFValue(16)}px 0 ${RFValue(14)}px;
`;

/* ── MOCKS LIST ── */

export const EmptyBox = styled.View`
  align-items: center;
  padding: ${RFValue(20)}px 0;
  gap: ${RFValue(8)}px;
`;

export const EmptyIcon = styled(FontAwesome)`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(36)}px;
`;

export const EmptyText = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(12)}px;
`;

export const MockItem = styled.View`
  flex-direction: row;
  align-items: center;
  background-color: ${({theme}) => theme.colors.price_card};
  border-radius: ${RFValue(12)}px;
  padding: ${RFValue(10)}px ${RFValue(12)}px;
  margin-bottom: ${RFValue(8)}px;
  gap: ${RFValue(10)}px;
`;

export const MockIconWrap = styled.View`
  background-color: ${({theme}) => theme.colors.primary}20;
  width: ${RFValue(32)}px;
  height: ${RFValue(32)}px;
  border-radius: ${RFValue(9)}px;
  justify-content: center;
  align-items: center;
`;

export const MockScreenIcon = styled(FontAwesome)`
  color: ${({theme}) => theme.colors.primary};
  font-size: ${RFValue(14)}px;
`;

export const MockInfo = styled.TouchableOpacity`
  flex: 1;
`;

export const MockLabel = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(13)}px;
`;

export const MockMeta = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(10)}px;
  margin-top: ${RFValue(2)}px;
`;

export const MockActions = styled.View`
  flex-direction: row;
  align-items: center;
  gap: ${RFValue(6)}px;
`;

export const NavigateButton = styled.TouchableOpacity`
  background-color: ${({theme}) => theme.colors.primary};
  border-radius: ${RFValue(8)}px;
  width: ${RFValue(30)}px;
  height: ${RFValue(30)}px;
  justify-content: center;
  align-items: center;
`;

export const NavigateIcon = styled(FontAwesome)`
  color: ${({theme}) => theme.colors.shape};
  font-size: ${RFValue(12)}px;
`;

export const DeleteButton = styled.TouchableOpacity`
  background-color: ${({theme}) => theme.colors.attention}15;
  border-radius: ${RFValue(8)}px;
  width: ${RFValue(30)}px;
  height: ${RFValue(30)}px;
  justify-content: center;
  align-items: center;
`;

export const DeleteIcon = styled(FontAwesome)`
  color: ${({theme}) => theme.colors.attention};
  font-size: ${RFValue(13)}px;
`;

export const MockCountBadge = styled.View`
  background-color: ${({theme}) => theme.colors.primary};
  border-radius: ${RFValue(10)}px;
  min-width: ${RFValue(18)}px;
  height: ${RFValue(18)}px;
  justify-content: center;
  align-items: center;
  padding: 0 ${RFValue(5)}px;
  margin-left: ${RFValue(6)}px;
`;

export const MockCountText = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.shape};
  font-size: ${RFValue(9)}px;
`;

export const SectionRow = styled.View`
  flex-direction: row;
  align-items: center;
  margin-bottom: ${RFValue(10)}px;
`;
